import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const apiCtx = React.createContext({});
export const useApi = () => React.useContext(apiCtx);
export const ApiProvider = ({ children, api, token }) => (_jsx(apiCtx.Provider, { value: { api, token }, children: children }));
export default ApiProvider;
//# sourceMappingURL=ApiProvider.js.map